import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Input from 'react-toolbox/lib/input'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'
import * as R from 'ramda'
import P from 'helpers/predicates'

import styles from './styles.scss'

const isNilOrEmpty = R.either(
  R.isEmpty,
  R.isNil
)

const RejectInput = ({value, onChange}) => {
  return (
    <Input
      theme={styles}
      type='text'
      label={T.translate('containers.approval.approvalDialog.rejectDialog.label')}
      multiline
      error={isNilOrEmpty(value) ? 'Please enter a reason' : undefined}
      value={value}
      onChange={onChange}
    />
  )
}

const withStyle = CSSModules(styles)
export default withStyle(RejectInput)
